import { Directive, Input, TemplateRef, ViewContainerRef } from "@angular/core";
import { IRequestPermission } from "@schema/permissions";
import { PermissionService } from "@core/service/permission.service";

@Directive({
  selector: "[appShowIfUserCan]"
})
export class ShowIfUserCanDirective {

  /**
   * If the current template is already shown
   */
  protected hasView = false;

  constructor(
    protected _templateRef: TemplateRef<any>,
    protected _viewContainer: ViewContainerRef,
    protected _permissionService: PermissionService,
  ) { }

  @Input("appShowIfUserCan") set appShowIfUserCan(request: IRequestPermission) {
    const userCan = this._permissionService.can(request.permission, request.global);

    if (userCan && !this.hasView) {
      this._viewContainer.createEmbeddedView(this._templateRef);
      this.hasView = true;
    } else if (!userCan && this.hasView) {
      this._viewContainer.clear();
      this.hasView = false;
    }
  }
}
